import React, {Component} from "react";
import {connect} from "react-redux";

import * as actions from "../actions/serverActions";
import * as barcodeActions from "../actions/barcodeActions";
import * as componentType from "../constants/componentTypes";
import * as navigationActions from "../actions/navigationActions";
import * as helperActions from "../actions/helperActions";
import * as translationHelper from "../helpers/translationHelper";
import * as windowService from "../services/windowService";

import AppComponent from "../components/App";

class App extends Component {
    componentDidMount = () => {
        windowService.logMessage(
            "Version " + this.props.softwareVersion + " (rev " + this.props.softwareRevision + ")."
        );
        windowService.writeVersionFile(this.props.software, this.props.softwareCode, this.props.softwareVersion);

        this.initTranslations();

        window.addEventListener("keydown", this.appKeyDown);
        window.addEventListener("mousemove", this.mouseMove);
        window.addEventListener("resize", this.windowResized);

        window.storeProvider.startInterval();
    };

    componentWillUnmount() {
        this.props.dispatchDisconnectFromServer();

        window.removeEventListener("keydown", this.appKeyDown);
        window.removeEventListener("mousemove", this.mouseMove);
        window.removeEventListener("resize", this.windowResized);

        window.storeProvider.clearInterval();
    }

    appKeyDown = (event) => {
        window.storeProvider.resetUserIdleTime();
        this.props.dispatchProcessKeyboardEventAction(event);
    };

    mouseMove = () => {
        window.storeProvider.resetUserIdleTime();

        if (this.props.screenSaver) {
            this.props.dispatchCloseScreenSaverAction();
        }
    };

    windowResized = () => {
        this.props.dispatchWindowResizedAction();
    };

    initTranslations = () => {
        windowService.loadCustomTranslations(
            this.props.languages.map((language) => language.code),
            function () {
                translationHelper.initializeTranslations(
                    this.props.languages,
                    this.props.language,
                    windowService.getCustomTranslations()
                );

                if (!this.props.gammaSoftware || (this.props.gammaSoftware && this.props.module !== null)) {
                    this.props.dispatchConnectLocalServerAction();
                    this.props.dispatchConnectHelperAction();
                }
            }.bind(this)
        );
    };

    backgroundClick = () => {
        if (this.props.blocked) {
            return;
        }

        if (this.props.activeModal === 0) {
            this.props.dispatchCloseMenuAction();
        }
        if (this.props.manualScan) {
            this.props.dispatchHideManualScanAction();
        }
        if (!this.props.manualScan && this.props.activeModal > 0) {
            if (this.props.modalList[this.props.modalList.length - 1].type !== componentType.PARTIAL_UPDATE_MODAL) {
                this.props.dispatchCloseTopModal(this.props.modalList[this.props.modalList.length - 1].type);
            }
        }
        if (this.props.activeNotificationPanel) {
            this.props.dispatchCloseNotificationPanel();
        }
    };

    render() {
        return (
            <AppComponent
                module={this.props.module}
                plugins={this.props.plugins}
                softwareStyle={this.props.softwareStyle}
                customStyle={this.props.customStyle}
                connected={this.props.connected}
                initialized={this.props.initialized}
                applicationStatus={this.props.applicationStatus}
                activeMenu={this.props.activeMenu}
                activeModal={this.props.activeModal}
                modalList={this.props.modalList}
                activeTab={this.props.activeTab}
                tabList={this.props.tabList}
                blocked={this.props.blocked}
                activeDialog={this.props.activeDialog}
                flashMessages={this.props.flashMessages}
                zoom={this.props.zoom}
                keyBoard={this.props.keyBoard}
                machineDialogType={this.props.machineDialogType}
                spectroDialogMessage={this.props.spectroDialogMessage}
                activeNotificationPanel={this.props.activeNotificationPanel}
                rendered={this.props.rendered}
                backgroundClick={this.backgroundClick}
                setupSoftware={this.props.setupSoftware}
                manualScan={this.props.manualScan}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        software: store.module.software,
        softwareCode: store.module.softwareCode,
        softwareStyle: store.module.softwareStyle,
        softwareVersion: store.module.softwareVersion,
        softwareRevision: store.module.softwareRevision,
        gammaSoftware: store.module.gammaSoftware,
        module: store.module.name,
        plugins: store.module.plugins,
        setupSoftware: store.module.setupSoftware,
        connected: store.server.connected,
        initialized: store.global.initialized,
        applicationStatus: store.navigation.status,
        activeMenu: store.navigation.activeMenu,
        activeModal: store.navigation.modalList.length,
        modalList: store.navigation.modalList,
        activeTab: store.navigation.activeTab,
        tabList: store.navigation.tabList,
        blocked: store.navigation.blocked,
        activeDialog: store.navigation.activeDialog,
        flashMessages: store.navigation.flashMessages,
        zoom: store.settings.zoom,
        screenSaver: store.navigation.screenSaver,
        keyBoard: store.virtualKeyboard.keyboardState,
        machineDialogType: store.rcc.machine.dialog === null ? null : store.rcc.machine.dialog.type,
        spectroDialogMessage: store.spectro.spectro.dialog === null ? null : store.spectro.spectro.dialog.message,
        customStyle: store.settings.style,
        language: store.settings.locale,
        languages: store.lang.languages,
        activeNotificationPanel: store.navigation.activeNotificationPanel,
        rendered: store.navigation.rendered,
        manualScan: store.barcode.manualScan
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchDisconnectFromServer: () => {
            dispatch(actions.serverDisconnect());
        },
        dispatchCloseTopModal: (modalType) => {
            dispatch(navigationActions.closeModal(modalType));
        },
        dispatchConnectLocalServerAction: () => {
            dispatch(actions.connectDefaultServer());
        },
        dispatchCloseMenuAction: () => {
            dispatch(navigationActions.hideMenu());
        },
        dispatchCloseScreenSaverAction: () => {
            dispatch(navigationActions.closeScreenSaver());
        },
        dispatchProcessKeyboardEventAction: (keyboardEvent) => {
            dispatch(navigationActions.processKeyboardEvent(keyboardEvent));
        },
        dispatchConnectHelperAction: (ip) => {
            dispatch(helperActions.connectHelper(ip));
        },
        dispatchCloseNotificationPanel: () => {
            dispatch(navigationActions.setNotificationPanel(false));
        },
        dispatchWindowResizedAction: () => {
            dispatch(navigationActions.windowResized());
        },
        dispatchHideManualScanAction: () => {
            dispatch(barcodeActions.showManualScan(false));
        }
    };
};

export default App = connect(mapStoreToProps, mapDispatchToProps)(App);
